import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IObjektNutzungsQueryShapes, ObjektNutzungsQueryFilterConfig } from 'fa-kt.types';
import { ObjektNutzungsService } from '../service';

@Component({
  selector: 'fa-kt-objekt-nutzungs-filter',
  templateUrl: './objekt-nutzungs-filter.component.html',
  styleUrls: ['./objekt-nutzungs-filter.component.css'],
})
export class ObjektNutzungsFilterComponent {
  readonly subscriptions: Subscription[] = [];

  ObjektNutzungsFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public objektNutzungs: ObjektNutzungsService,
  ) {
    this.ObjektNutzungsFilterConfig = ObjektNutzungsQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.objektNutzungs.shapes$.subscribe((shapes: IObjektNutzungsQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ObjektNutzungsFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ObjektNutzungsFilterConfig[index].selections = shapes;
  }
}
